<!-- 大纲 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="contents_name">
                <el-input v-model="ruleForm.contents_name"></el-input>
            </el-form-item>
            <el-form-item label="上级" prop="parent_contents_id">
                <el-select v-model="ruleForm.parent_contents_id" placeholder="请选择"  :disabled="disabled" style="width:100%">
                    <el-option v-for="item in options" :key="item.contents_id" :label="item.contents_name"
                        :value="item.contents_id">
                    </el-option>
                </el-select>
                <!-- <el-cascader v-model="ruleForm.parent_contents_id" :options="options" :props="{
                    checkStrictly: true,
                    label: 'contents_name',
                    value: 'contents_id',
                    children: 'children'

                }" clearable></el-cascader> -->

            </el-form-item>


        </el-form>
        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '新建大纲',
            ruleForm: {
                "parent_contents_id": "",
                "contents_name": "",
                "outline_id": ""//课程信息列表 ID
            },
            options: [],
            disabled: false,
            rules: {
                contents_name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },

                ],
                parent_contents_id: [
                    { required: false, message: '请选择上级', trigger: 'change' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        init(outline_id){
            this.ruleForm = {
                "parent_contents_id": "",
                "contents_name": "",
                "outline_id": outline_id//课程信息列表 ID
            }
            this.getOptions()
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {


                    let obj = {
                        ...this.ruleForm,

                    }
                    // obj.parent_contents_id = obj.parent_contents_id.length ? obj.parent_contents_id[0] : ''
                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.trainingOutlineAdd, {
                            data: obj
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '添加成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data:  {
                        outline_id: this.ruleForm.outline_id
                    }
                }).then((res) => {
                    if (res.data.code == 0) {
                        if (res.data.data && res.data.data.length > 0) {
                            res.data.data.forEach(item => {
                                item.fold = true
                            })
                            this.options = res.data.data
                        } else {
                            this.options = []
                        }


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped></style>